import { createContext } from 'react';

export const ValidateDeviceContext = createContext();
export const ValidateDeviceDispatchContext = createContext();
